import { render, staticRenderFns } from "./DateDisplay.vue?vue&type=template&id=1223d97e&scoped=true"
import script from "./DateDisplay.vue?vue&type=script&lang=js"
export * from "./DateDisplay.vue?vue&type=script&lang=js"
import style0 from "./DateDisplay.vue?vue&type=style&index=0&id=1223d97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223d97e",
  null
  
)

export default component.exports